import axios from '@/plugins/axios'

const home = {
  namespaced: true,
  state: {
    data: {}
  },
  actions: {
    get({ commit }, params) {
      axios.get('/home/', { params })
        .then(({ data }) => {
          commit('updateData', data)
        })
    }
  },
  mutations: {
    updateData(state, data) {
      state.data = data
    }
  }
}

export default home
